import React, { useEffect } from "react";
import { connect } from "react-redux";
import { toast } from "react-toastify";
import { withRouter } from "react-router";

import * as actions from "../../../store/actions";
import constants, { getDashboardPath } from "../../../constants";
import { VALIDATE_AVAILABILITY_SCHEDULE } from "../../../store/actions/actionTypes";
import { convertTimeTo12HourFormat } from "../../../utils/parseDateTime";
import "../../../layout/Dashboard/dashboardStyle.css";

import Button from "../../../components/formElements/button/Button";

const AvailabilitySchedule = ({
  availabilitySchedule,
  setAvailabilitySchedule,
  setUnavailabilitySchedule,
  getSlots,
  saveAvailabilitySchedule,
  history,
  form,
  validateData,
  getDoctorDetails,
}) => {
  useEffect(() => {
    getDoctorDetails(() => getSlots());
    // eslint-disable-next-line
  }, []);

  useEffect(() => {
    getSlots();
    // eslint-disable-next-line
  }, [availabilitySchedule.scheduledDate]);

  useEffect(() => {
    if (form && form.availabilityScheduleValid) {
      saveAvailabilitySchedule();
    }
    form.availabilityScheduleValid = false;
    toast.error(form.scheduleValid, {
      position: constants.TOAST_POSITION,
    });
    // eslint-disable-next-line
  }, [form]);

  const morningSlots = availabilitySchedule?.slots?.morningSlots;
  const afternoonSlots = availabilitySchedule?.slots?.afternoonSlots;
  const eveningSlots = availabilitySchedule?.slots?.eveningSlots;

  const morningCount = availabilitySchedule?.count?.morningCount;
  const afternoonCount = availabilitySchedule?.count?.afternoonCount;
  const eveningCount = availabilitySchedule?.count?.eveningCount;

  const notAvailableEntireDay = availabilitySchedule.notAvailableEntireDay;

  const engagedSlots = availabilitySchedule?.engaged_slots;

  return (
    <div>
      <div className="row mt-2">
        <div
          className="col-md-6"
          style={{
            fontSize: 18,
          }}
        >
          Choose unavailable slots
        </div>
        <div className="col-md-6 mb-5">
          <div className=" custom-switch custom-switch-md float-right">
            <input
              type="checkbox"
              className="custom-control-input"
              id="customSwitches"
              disabled={!availabilitySchedule.slots}
              onChange={e =>
                setAvailabilitySchedule({
                  notAvailableEntireDay: e.target.checked,
                })
              }
              checked={notAvailableEntireDay}
            />
            <label
              className="custom-control-label"
              htmlFor="customSwitches"
              style={{
                fontSize: 16,
              }}
            >
              Not available for entire day
            </label>
          </div>
        </div>
        <div className="col-md-12 mb-4">
          <p className="schedule-period">Morning</p>
          {parseInt(morningCount) > 0 && (
            <span className="slot-count">
              ({morningCount} unavailable slots)
            </span>
          )}
          <div className="mt-3">
            {morningSlots?.length > 0 ? (
              morningSlots?.map(slot => (
                <div
                  onClick={() => setUnavailabilitySchedule(slot)}
                  className="slot"
                  style={{
                    backgroundColor:
                      notAvailableEntireDay ||
                      availabilitySchedule.unavailable_slots.includes(slot) ||
                      engagedSlots?.includes(slot)
                        ? "var(--faint-color)"
                        : "white",
                    pointerEvents:
                      (notAvailableEntireDay || engagedSlots?.includes(slot)) &&
                      "none",
                  }}
                >
                  <span className="content-center">{convertTimeTo12HourFormat(slot)} </span>
                </div>
              ))
            ) : (
              <p className="content-center">No morning slots found</p>
            )}
          </div>
        </div>
        <div className="col-md-12 mb-4">
          <p className="schedule-period">Afternoon</p>
          {parseInt(afternoonCount) > 0 && (
            <span className="slot-count">
              ({afternoonCount} unavailable slots)
            </span>
          )}
          <div className="mt-3">
            {afternoonSlots?.length > 0 ? (
              afternoonSlots?.map(slot => (
                <div
                  onClick={() => setUnavailabilitySchedule(slot)}
                  className="slot"
                  style={{
                    backgroundColor:
                      notAvailableEntireDay ||
                      availabilitySchedule.unavailable_slots.includes(slot) ||
                      engagedSlots?.includes(slot)
                        ? "var(--faint-color)"
                        : "white",
                    pointerEvents:
                      (notAvailableEntireDay || engagedSlots?.includes(slot)) &&
                      "none",
                  }}
                >
                  <span className="content-center">{convertTimeTo12HourFormat(slot)} </span>
                </div>
              ))
            ) : (
              <p className="content-center">No afternoon slots found</p>
            )}
          </div>
        </div>

        <div className="col-md-12 mb-4">
          <p className="schedule-period">Evening</p>
          {parseInt(eveningCount) > 0 && (
            <span className="slot-count">
              ({eveningCount} unavailable slots)
            </span>
          )}
          <div className="mt-3">
            {eveningSlots?.length > 0 ? (
              eveningSlots?.map(slot => (
                <div
                  onClick={() => setUnavailabilitySchedule(slot)}
                  className="slot"
                  style={{
                    backgroundColor:
                      notAvailableEntireDay ||
                      availabilitySchedule.unavailable_slots.includes(slot) ||
                      engagedSlots?.includes(slot)
                        ? "var(--faint-color)"
                        : "white",
                    pointerEvents:
                      (notAvailableEntireDay || engagedSlots?.includes(slot)) &&
                      "none",
                  }}
                >
                  <span className="content-center">{convertTimeTo12HourFormat(slot)} </span>
                </div>
              ))
            ) : (
              <p className="content-center">No evening slots found</p>
            )}
          </div>
        </div>
      </div>
      {availabilitySchedule.slots && (
        <div className="col-md-4 d-flex justify-content-between align-items-center">
          <Button
            label="Save"
            className=" mr-3"
            disabled={
              !availabilitySchedule.schedule_id &&
              availabilitySchedule.unavailable_slots.length === 0 &&
              !notAvailableEntireDay
            }
            onClick={() => validateData(availabilitySchedule)}
          />
          <Button
            type="outline"
            label="Cancel"
            className="btn-block"
            onClick={() => history.push(getDashboardPath("/appointments"))}
          />
        </div>
      )}
    </div>
  );
};

const mapStoreToProps = ({ dashboard, validation }) => ({
  availabilitySchedule: dashboard.availabilitySchedule,
  form: validation.data,
});

const mapDispatchToProps = dispatch => ({
  getDoctorDetails: cb => dispatch(actions.getDoctorDetails(undefined, cb)),
  setAvailabilitySchedule: updatedData =>
    dispatch(actions.setAvailabilitySchedule(updatedData)),
  setUnavailabilitySchedule: slot =>
    dispatch(actions.setUnavailabilitySchedule(slot)),
  getSlots: () => dispatch(actions.getSlots()),
  saveAvailabilitySchedule: () => dispatch(actions.saveAvailabilitySchedule()),
  validateData: availabilityScheduleData =>
    dispatch(
      actions.validateData(
        VALIDATE_AVAILABILITY_SCHEDULE,
        availabilityScheduleData
      )
    ),
});

export default withRouter(
  connect(mapStoreToProps, mapDispatchToProps)(AvailabilitySchedule)
);
